module.exports = __webpack_public_path__ + "static/media/defaultPreviewImg.06f948df.jpg";